// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"efb8b753","364":"59c052c6","453":"87c7a27e","951":"f2abea34"}[chunkId] + ".chunk.js";
};